import { useState, type ReactNode } from "react";

export interface AccordionItem {
  id: string;
  question: string;
  answer: string | ReactNode;
}

interface AccordionProps {
  items: AccordionItem[];
}

export function Accordion({ items }: AccordionProps) {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) =>
    setOpenId((prev) => (prev === id ? null : id));

  return (
    <div className="flex flex-col gap-3">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div
            key={item.id}
            id={item.id}
            className="bg-bg-secondary/60 border border-border-primary rounded-2xl overflow-hidden transition-colors duration-200"
          >
            <button
              onClick={() => toggle(item.id)}
              className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
            >
              <h3 className="text-base font-semibold text-white">
                {item.question}
              </h3>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`w-5 h-5 flex-shrink-0 text-text-tertiary transition-transform duration-200 ${
                  isOpen ? "rotate-180" : ""
                }`}
              >
                <path d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            <div
              className={`grid transition-all duration-200 ${
                isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
              }`}
            >
              <div className="overflow-hidden">
                {typeof item.answer === "string" ? (
                  <p className="px-6 pb-5 text-text-secondary text-sm leading-relaxed">
                    {item.answer}
                  </p>
                ) : (
                  <div className="px-6 pb-5 text-text-secondary text-sm leading-relaxed">
                    {item.answer}
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
